<template>
    <div id="debugList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        Debugbar
                    </div>
                    <div class="lineitem-main-section" style="margin-top:100px;">
                        <table aria-describedby="table" class="table table-condensed"  id="workOrder-table" style="border-collapse:collapse;">
                            <tbody v-for="(request, index) in requestList" :key="index" class="line-item-internal-section customer-view-main workorder-accordion-section">
                                <tr class="accordion-tr"> <!--Accordion 1 content-->
                                    <td class="accordion-main-table">
                                        <table aria-describedby="table" class="table table-condensed">
                                            <tr data-toggle="collapse" @click="getRequestDetails(request.file,request.id)" class="accordion-toggle">
                                                <td>
                                                    <div class="checkbox">
                                                        <span>{{request.uri}}</span>
                                                    </div>
                                                </td>

                                                <td>
                                                    <label class="lineItem-label"> Date: </label>
                                                    <span class="lineItem-value"> {{request.dateTime}} </span>
                                                </td>

                                                <td>
                                                    <label class="lineItem-status-label"> Method: </label>
                                                    <span class="lineItem-status-value"> {{request.method}} </span>
                                                </td>
                                                <td>
                                                    <label class="lineItem-status-label"> Time: </label>
                                                    <span class="sublet-status-yes">{{request.time}}</span>
                                                </td>

                                                <td class="accordion-down-arrow"> <i class="hi-icon icon-fldown-arrow"></i> </td>
                                            </tr>
                                            <tr>
                                                <td colspan="5" class="hiddenRow">
                                                    <div :id="'demo_'+request.id" class="accordian-body Work-order-accordion-content collapse">
                                                        <div class="Work-order-detail-section col-xs-12">
                                                            <div class="row">
                                                                <!-- <div class="row">
                                                                    <div class="workorder-detail-list col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                                                        <p>
                                                                            <span class="customer-detail-rv-title"> Time Start :</span>
                                                                            <span class="customer-detail-rv"></span>
                                                                        </p>

                                                                        <p>
                                                                            <span class="customer-detail-rv-title"> Time End: </span>
                                                                            <span class="customer-detail-rv">  </span>
                                                                        </p>

                                                                        <p>
                                                                            <span class="customer-detail-rv-title"> Time Duration: </span>
                                                                            <span class="customer-detail-rv"></span>
                                                                        </p>
                                                                    </div>
                                                                </div> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                            <div class="col-sm-12" style="margin-bottom:15px;">
                                <div class="page-text pull-right">
                                    <a href="javascript:void(0)" class="btn btn-primary" id="prevPage" v-on:click="MoveOnpage('prev')">
                                        Prev
                                        <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                                    </a>
                                    <!-- <a href="javascript:void(0)" class="btn btn-primary" id="prevPage" v-show="prev_disable" :disabled='true'>
                                        Prev
                                        <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                                    </a> -->
                                     <a href="javascript:void(0)" class="btn btn-primary" v-on:click="MoveOnpage('next')" id="nextPage">
                                        Next
                                        <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                    </a>
                                    <!-- <a href="javascript:void(0)" class="btn btn-primary" v-show="next_disable" v-bind:disabled="true" id="nextPage">
                                        Next
                                        <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                    </a> -->
                                </div>
                            </div>
                        </table>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";


    import {commonMixins} from '../../mixins/commonMixins';


    export default {
        name: "debugList",
        mixins:[commonMixins],
        data: () => ({
            permissions: [],
            cantAccessPage: "",
            requestList: [],
            loading:false,
            perPage:10,
            page:1,
            prev_disable:false,
            next_disable:false,
            totalRecords:0,
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_faq') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            setTimeout(function(){

                $("#prevPage").addClass('js-example-disabled');

            },500);
            //when component list directly call from url instead of in view page than call permission request
            self.getPermissions();
            self.getAllRequests();
        },
        methods: {
            MoveOnpage: function(flag){

                var self = this;

                if (flag == 'prev'){
                    $("#nextPage").removeClass('js-example-disabled');
                    if ( self.page > 1){
                        self.page = self.page - 1;
                        self.prev_disable = false;
                        if (self.page > 1){

                            $("#prevPage").removeClass('js-example-disabled');

                        }else{
                            $("#prevPage").addClass('js-example-disabled');
                        }
                    }else{
                        self.prev_disable = true;
                        $("#prevPage").addClass('js-example-disabled');
                    }
                }else{
                    var total = self.page * self.perPage;
                    if (self.totalRecords > 0 && self.totalRecords <= total){
                        // self.next_disable = true;
                         $("#nextPage").addClass('js-example-disabled');
                    }else{

                        self.page = self.page + 1;
                        self.next_disable = false;
                        $("#prevPage").removeClass('js-example-disabled');
                        $("#nextPage").removeClass('js-example-disabled');
                    }
                }

                self.getAllRequests();
            },

            getAllRequests() {

                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/debugbar",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        perPage:self.perPage,
                        page:self.page
                    },
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.requestList = data.content;
                            self.totalRecords = data.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            getRequestDetails(file,id) {

                var self = this;

                if ( $("#demo_"+id+" .workorder-detail-list").length > 0 ) {
                    $("#demo_"+id).collapse('toggle');
                    return;
                }

                $.ajax({
                    url: process.env.ROOT_API + "/debugbar/details",
                    type: "GET",
                    headers: this.ajxHeaders,
                    data: {
                        // file: file,
                        id:id
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            var content = data.content;
                            var html = '<div class="row"><div class="workorder-detail-list col-xs-12 col-sm-4 col-md-4 col-lg-4">'+
                                            '<p><span class="customer-detail-rv-title"> Time Start :</span>'+
                                                '<span class="customer-detail-rv">'+content.time.start+'</span></p>'+

                                            '<p><span class="customer-detail-rv-title"> Time End: </span>'+
                                                '<span class="customer-detail-rv">'+content.time.end+'</span></p>'+

                                            '<p><span class="customer-detail-rv-title"> Time Duration: </span>'+
                                                '<span class="customer-detail-rv">'+content.time.duration_str+'</span></p>'+
                                        '</div>'+
                                        '<div class="workorder-detail-list col-xs-12 col-sm-4 col-md-4 col-lg-4">'+
                                            '<p><span class="customer-detail-rv-title"> Memory Usage :</span>'+
                                                '<span class="customer-detail-rv">'+content.memory.peak_usage_str+'</span></p>'+

                                            '<p><span class="customer-detail-rv-title"> No. Of Queries: </span>'+
                                                '<span class="customer-detail-rv">'+content.queries.nb_statements+'</span></p>'+

                                            '<p><span class="customer-detail-rv-title"> Query Time: </span>'+
                                                '<span class="customer-detail-rv">'+content.queries.accumulated_duration_str+'</span></p>'+
                                        '</div></div>';

                            if ( content.queries.statements.length > 0 ) {
                                for ( var i=0; i<content.queries.statements.length; i++ ) {
                                    html += '<hr><div class="row">'+
                                                '<div class="col-md-2"><span class="customer-detail-rv-title">Query</span></div>'+
                                                '<div class="col-md-10"><span class="customer-detail-rv">'+content.queries.statements[i].sql+'</span></div>'+
                                                '<div class="col-md-2"><span class="customer-detail-rv-title">Query Time</span></div>'+
                                                '<div class="col-md-10"><span class="customer-detail-rv">'+content.queries.statements[i].duration_str+'</span></div>'+
                                            '</div>';
                                }
                            }

                            $("#demo_"+id+' .row').append(html);
                            $("#demo_"+id).collapse('toggle');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            }

        }
    };
</script>
<style scoped>
.js-example-disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Debugbar.vue